import React from 'react';
import PropTypes from 'prop-types';
import { humanize } from 'underscore.string';
import { useTranslation } from 'react-i18next';
import DateField from './DateField';
import Checkbox from '../../../v2/forms/Checkbox';
import formatMoney from 'utils/formatters/Money';
import { Card, CardContent, CardHeader, CardTitle, Table, TableBody, TableCell, TableHead, TableHeader, TableRow, } from '@cargomatic/ui';
export default function VendorPayables({ charges, timezone, total, shipmentId, showConfirmation, }) {
    var _a;
    const { t } = useTranslation();
    return (React.createElement("div", { "data-testid": "div-99063d4c" },
        React.createElement(Card, { "data-testid": "div-ca6f5376", className: "" },
            React.createElement(CardHeader, null,
                React.createElement(CardTitle, { "data-testid": "h3-a3c28987", className: "" }, t('VENDOR_CHARGES'))),
            React.createElement(CardContent, { "data-testid": "div-6f5792f4", className: "overflow-x-auto" },
                React.createElement(Table, { "data-testid": "table-cc10d20b", className: "" },
                    React.createElement(TableHeader, { "data-testid": "thead-6cd7a0c8" },
                        React.createElement(TableRow, { "data-testid": "tr-7b4c9cbb" },
                            React.createElement(TableHead, { "data-testid": "th-9edb5005", className: "w-48" }, t('CHARGE')),
                            React.createElement(TableHead, { "data-testid": "th-09825bc6", className: "w-20" }, t('COST')),
                            React.createElement(TableHead, { "data-testid": "th-ecc15e2e", className: "w-40" }, t('ENTERED_DATE')),
                            React.createElement(TableHead, { "data-testid": "th-19dc08e3", className: "w-40" }, t('PAID')),
                            React.createElement(TableHead, { "data-testid": "th-1e789897", className: "w-40" }, t('VENDOR')))),
                    React.createElement(TableBody, { "data-testid": "tbody-8d155a75" },
                        (charges || []).map((lineItem, index) => {
                            var _a;
                            return (React.createElement(TableRow, { "data-testid": `tr-8bb795a4-${index}`, key: lineItem._id },
                                React.createElement(TableCell, { "data-testid": `td-e411fdfc-${index}`, className: "break-words" },
                                    React.createElement("div", { "data-testid": `div-73229cc2-${index}`, className: "w-48" }, lineItem.message || humanize(lineItem.type))),
                                React.createElement(TableCell, { "data-testid": `td-25528f9b-${index}` }, formatMoney(lineItem.value, lineItem === null || lineItem === void 0 ? void 0 : lineItem.currency)),
                                React.createElement(TableCell, { "data-testid": `td-9d5dfaea-${index}` },
                                    React.createElement(DateField, { date: lineItem.timestamp, timezone: timezone })),
                                React.createElement(TableCell, { "data-testid": `td-ef8c913d-${index}` },
                                    React.createElement(Checkbox, { dataTestId: `Checkbox-b64bcae3-${index}`, checked: lineItem.payment_status === 'paid', onChange: () => showConfirmation(lineItem._id, shipmentId, lineItem.payment_status, lineItem.message, formatMoney(lineItem.value, lineItem === null || lineItem === void 0 ? void 0 : lineItem.currency)), className: "my-4", id: "port_events", name: "port_events" })),
                                React.createElement(TableCell, { "data-testid": `td-52f391a7-${index}` }, ((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.vendor) === null || _a === void 0 ? void 0 : _a.company_name)
                                    ? lineItem.vendor.company_name
                                    : 'NA')));
                        }),
                        React.createElement(TableRow, { "data-testid": "tr-32c7151b" },
                            React.createElement(TableCell, { "data-testid": "td-fe8a1065", className: "font-bold" },
                                React.createElement("div", { "data-testid": "div-e4706754", className: "w-48" }, t('TOTAL'))),
                            React.createElement(TableCell, { "data-testid": "td-6d6afcea", className: "font-bold" }, formatMoney(total, (_a = charges[0]) === null || _a === void 0 ? void 0 : _a.currency)),
                            React.createElement(TableCell, { "data-testid": "td-33319d09", colSpan: 5 }, "\u00A0"))))))));
}
VendorPayables.propTypes = {
    charges: PropTypes.arrayOf(PropTypes.shape({
        _id: PropTypes.string,
        value: PropTypes.number,
        type: PropTypes.string,
        message: PropTypes.string,
        timestamp: PropTypes.string,
    })),
    total: PropTypes.number,
    timezone: PropTypes.string,
};
VendorPayables.defaultProps = {
    total: 0,
    timezone: 'America/Los_Angeles',
};
